import { render, staticRenderFns } from "./link-user-wechat.vue?vue&type=template&id=6e4d7f4c&"
import script from "./link-user-wechat.vue?vue&type=script&lang=ts&"
export * from "./link-user-wechat.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports